export default __webpack_public_path__ + "static/media/background.b8ab9ac4.jpg";